/**
 * Localization utility implementing modapp's model interface.
 */

import L10n from 'classes/L10n.js';
import eventBus from 'modapp-eventbus';

/**
 * L10n instance using the {@link module:modapp/eventBus} to emit locale changes.
 * @type {L10n}
 */
let l10n = new L10n(eventBus);

export default l10n;
